
<template>
  <v-app id="searchValu">
    <v-main>
    <v-container fluid>  
    <v-card>
      <v-card-title>Currencies</v-card-title>
      <v-simple-table dense>
         <tbody v-for="(valuRecord,i) in searchValu" :key="i">
           <tr @click="$router.reload('/syst/ref/valu/onValu/' + valuRecord.valu_encrid)">
             <td>{{valuRecord.valu_code}}</td>
             <td>{{valuRecord.valu_oms}}</td>
           </tr>  
         </tbody>  
       </v-simple-table>  
    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/>    
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  data() {
    return {
      searchValu: []
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/syst/ref/valu/searchValu.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchValu"
          },
          searchValu: {
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.searchValu = res.data.searchValu;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
};

</script> 
